
export default function sanitize(string) {
  return string ? string.replace(/[^\w äÄöÖåÅüÜ#-.]/g, '').trim().replace(/\s\s+/g, ' ') : ''
}
